import { FasterConfigurationOptions } from './FasterConfigurationOptions';

class FasterConfiguration {
  public static readonly FASTER_PLATFORM: string = 'WEB';
  public static readonly FASTER_APP_VERSION?: string;
  public static readonly FASTER_SDK_VERSION: string = 'process.env.SDK_VERSION';
  public static readonly FASTER_APP_KEY_HEADER = 'X-fstr-application-key';
  public static readonly FASTER_SIGNATURE_HEADER = 'X-fstr-signature';

  public readonly apiKey: string;
  public readonly secretKey: string;
  public readonly options: FasterConfigurationOptions;
  public readonly eventRetryTimeout: number = 2000;
  public readonly eventRetryMax: number = 10;

  public readonly baseUrl: string = 'https://api.fstr.rocks/';

  public constructor(apiKey: string, secretKey: string, options: FasterConfigurationOptions) {
    const defaultOptions = {
      appVersion: 'undefined',
      sessionTtl: 300,
      connectTimeout: 30000,
      readTimeout: 30000,
      writeTimeout: 30000,
      sessionProperties: {},
    };

    this.options = defaultOptions;

    if (options === null || options === undefined) {
      console.warn(`FasterConfigurationOptions was not properly defined, the received value was: ${options}`);
    } else if (options.appVersion === null || options.appVersion === undefined) {
      console.warn(`AppVersion was not properly defined, the received value was: ${options.appVersion}`);
    } else {
      this.options = {
        ...this.options,
        ...options,
      };
    }

    this.apiKey = apiKey;
    this.secretKey = secretKey;
  }
}

export default FasterConfiguration;
